export default{
    main:{
        message:"消息",
        display:'显示'
    }

}